//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DateComp from "@/components/public/DateComp";
export default {
  name: "ServeCountForDept",
  components: {
    DateComp: DateComp
  },
  props: ["queryRang"],
  data: function data() {
    return {
      loading: false,
      list: []
    };
  },
  created: function created() {},
  computed: {},
  mounted: function mounted() {
    this.fetchList();
  },
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true;
      var date = this.$refs.date.getValue();
      this.$http.post("serveCount/deptRanking", JSON.stringify({
        startDate: date[0],
        endDate: date[1],
        queryRang: this.queryRang
      }), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this.list = data.resData.list;
          _this.loading = false;
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    }
  }
};